import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { DELETE, GET, PUT } from '../../../services/rest.service';

import Add from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { convertJsonToFormData } from '../../../helpers/helper';
import { hideLoading, showLoading } from '../../../redux/loader/LoaderActions';

const SkillList = () => {
  const dispatch = useDispatch();
  const [records, setRecords] = useState([]);
  const [pages, setPages] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const editRecord = (record) => {
    navigate(`/admin/skills/update/${record._id}`);
  };

  const createRecord = () => {
    navigate(`/admin/skills/create`);
  };

  const deleteRecord = (record, index) => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to delete this nanny account? All their data will be lost forever.',
      icon: 'warning',
      buttons: ['No', 'Yes'],
    }).then((result) => {
      if (result) {
        // PATCH(`/admin/user/change_status/${record._id}`, { status: 'Deleted' })
        //   .then((res) => {
        //     const records = this.state.records;
        //     this.setState({
        //       records: [...records.slice(0, index), ...records.slice(index + 1)],
        //     });
        //   })
        //   .catch((err) => {
        //     toast.error(err.message);
        //   });
        DELETE(`/admin/skill/delete/${record._id}`)
          .then(() => {
            toast.success('Skill deleted successfully!');
            const updatedRecords = [...records];
            updatedRecords.splice(index, 1);
            setRecords(updatedRecords);
          })
          .catch((err) => {
            toast.error(err.message || 'Failed to delete skill');
          });
      }
    });
  };

  useEffect(() => {
    getPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPage = async (page) => {
    dispatch(showLoading());
    try {
      const { data } = await GET(`/admin/skills/get/${page}`);
      setRecords(data.Skills);
      setPages(data.Pages);
      setTotal(data.Total);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.message);
    }
  };

  const handlePageClick = (e) => {
    getPage(e.selected + 1);
  };

  const toggleSwitch = async (record, index) => {
    const payload = {
      skill_id: record._id,
      title: record.title,
      status: record.status,
      description: record.description,
      showOnHomePage: record.showOnHomePage ? 'false' : 'true',
    };
    const formData = convertJsonToFormData(payload);

    try {
      await PUT(`/admin/skill/${record._id}/edit`, formData);
      getPage(1);
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div className="container-fluid px-xl-5">
      <section className="py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className="text-uppercase mb-0">Skills</h6>
                <Button variant="outlined" color="secondary" sx={{ margin: 0, padding: '5px' }} onClick={createRecord}>
                  <Add />
                  Create
                </Button>
              </div>
              <div className="card-body">
                <table className="table card-text">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Icon</th>
                      <th>Title</th>
                      <th>Show On HomePage</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((record, index) => {
                      return (
                        <tr key={index}>
                          <th scope="row">{index + 1}</th>
                          <td>
                            <img width="60px" src={record.icon.url} alt={record.title} />
                          </td>
                          <td>{record.title}</td>
                          <td>
                            {' '}
                            <Switch color="secondary" onClick={() => toggleSwitch(record, index)} checked={record.showOnHomePage === true} />
                          </td>
                          <td className="text-center">
                            <IconButton color="primary" onClick={() => editRecord(record, index)} sx={{ margin: 0, padding: '5px' }} aria-label="Edit">
                              <EditIcon />
                            </IconButton>
                            <IconButton color="secondary" onClick={() => deleteRecord(record, index)} sx={{ margin: 0, padding: '5px' }} aria-label="Delete">
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="mx-auto my-4">
            <ReactPaginate
              previousLabel={'previous'}
              nextLabel={'next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              pageClassName={'page-item'}
              onPageChange={handlePageClick}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default SkillList;
